import { render, staticRenderFns } from "./payDialog.vue?vue&type=template&id=ca930800&scoped=true&"
import script from "./payDialog.vue?vue&type=script&lang=js&"
export * from "./payDialog.vue?vue&type=script&lang=js&"
import style0 from "./payDialog.vue?vue&type=style&index=0&id=ca930800&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca930800",
  null
  
)

export default component.exports